import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    selectedPacking: string[] | null;
}

type Props = OwnProps;

export interface PackingNotesValuesStyles {
    notesDescription?: InjectableCss;
    notesTitle: TypographyProps;
}

export const PackingNotesValuesStyles: PackingNotesValuesStyles = {
    notesDescription: {
        css: css`
            padding: 0;
            font-size: ${TYPOGRAPHY.size.smaller};
        `,
    },
    notesTitle: {
        variant: "h4",
        css: css`
            margin-bottom: 0.5rem;
            padding: 0;
        `,
    },
};

const styles = PackingNotesValuesStyles;

const PackingNotesValues: FC<Props> = ({ selectedPacking }) => {
    return (
        <>
            <Typography {...styles.notesTitle}>
                {translate("Packing List Notes and instructions (printed on packing list only)")}
            </Typography>
            {selectedPacking?.map((value, index) => {
                return (
                    <Typography {...styles.notesDescription} key={value}>
                        {/* {value} */}
                        {value === "BlindShip"
                            ? siteMessage("BlindShip")
                            : value === "ShipResidential"
                            ? siteMessage("ShipResidential")
                            : value === "ShipComplete"
                            ? siteMessage("ShipComplete")
                            : null}
                    </Typography>
                );
            })}
        </>
    );
};

export default PackingNotesValues;
